import { render, staticRenderFns } from "./HandleDomainStage.vue?vue&type=template&id=31226bb1"
import script from "./HandleDomainStage.vue?vue&type=script&lang=js"
export * from "./HandleDomainStage.vue?vue&type=script&lang=js"
import style0 from "./HandleDomainStage.vue?vue&type=style&index=0&id=31226bb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports